module.exports = __webpack_public_path__ + "img/arrow-right-icon.879c10e.svg";